import { createAction, createSlice } from "@reduxjs/toolkit";
import {
  Colors,
  FontWeight,
  Radius,
  Shadows,
  Spacing,
  ZIndex,
} from "../../constants/theme";

export const DefaultTheme = {
  colors: Colors,
  radius: Radius,
  shadows: Shadows,
  spacing: Spacing,
  fontWeight: FontWeight,
  zIndex: ZIndex,
};

export type ITheme = typeof DefaultTheme;
export const resetThemeState = createAction("theme/resetState");

export const themeSlice = createSlice({
  name: "theme",
  initialState: { theme: DefaultTheme },
  reducers: {
    fetchTheme: (state, action) => {
      state.theme = action.payload.theme;
    },
  },
});

export const { fetchTheme } = themeSlice.actions;

// Action creators are generated for each case reducer function

export default themeSlice.reducer;
